import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ISalesFunnelStage } from '../typings'
import { selectAllSalesFunnelStages } from '../slice'

export function useSelectOppStages(
  salesFunnelId: number,
): [
  stages: ISalesFunnelStage[],
  closedWonStageId: number,
  closedLostStageId: number,
  hasOnlySystemFields: boolean,
] {
  const stages = useSelector(selectAllSalesFunnelStages)

  return useMemo(() => {
    const oppStages = stages.filter(
      (s) =>
        s.sectionType === 'Opportunity' && s.salesFunnelId === salesFunnelId,
    )

    const closedWonStageId =
      oppStages.find((s) => s.name === 'Closed/Won')?.id ?? -1

    const closedLostStageId =
      oppStages.find((s) => s.name === 'Closed/Lost')?.id ?? -1
    const hasOnlySystemStages =
      oppStages.length == 2 && closedWonStageId > -1 && closedLostStageId > -1
    return [oppStages, closedWonStageId, closedLostStageId, hasOnlySystemStages]
  }, [salesFunnelId, stages])
}
